import { PlayerProjectionFragment } from '@/api/events/query.generated';
import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

export const useShouldShowCurrentValue = (projection?: PlayerProjectionFragment) => {
    const enableInPlayCurrentValue = useJurisdictionStore(
        store => store.jurisdictionSettings?.productConfig?.settings?.enable_inplay_current_value
    );

    return enableInPlayCurrentValue && !!projection?.currentValue && !projection?.liveScoringDisabled;
};
